export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/pingWorker.worker.fadab8f6.worker.js");
}
